import React, { memo } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

const KeyDatesSection = memo(({ theme, sectionId }) => {
  const KeyDatesLayout = dynamic(() => import(/* webpackChunkName: 'KeyDatesSectionLayout' */ `../../../../../containers/home-page/views/sections/key-dates/layouts/${theme.layout}`))

  return (
    <KeyDatesLayout sectionId={sectionId} />
  )
}, (prevProps, nextProps) => {
  return (prevProps.theme && prevProps.theme.layout) === (nextProps.theme && nextProps.theme.layout)
})

KeyDatesSection.propTypes = {
  theme: PropTypes.object,
  sectionId: PropTypes.number
}

export default KeyDatesSection
